export default function EntryCta() {
  return (
    <section id="entry" className="w-full border-b border-background-200 bg-background-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="relative overflow-hidden rounded-lg border border-background-200 bg-background-50">
          <div className="grid grid-cols-1 lg:grid-cols-12 items-center">
            <div className="lg:col-span-7 p-6 md:p-10">
              <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-700">
                <i className="ri-smartphone-line" />
                移动端浏览更顺手
              </span>
              <h2 className="mt-4 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                下载入口 · 把看料目录装进口袋
              </h2>
              <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600">
                收藏清单、订阅热度榜更新、按目录快速跳转，随时查看最新的黑料看料一览与盘点进度。
              </p>

              <div className="mt-7 flex flex-col sm:flex-row gap-3">
                <a
                  href="#top"
                  className="inline-flex h-12 items-center justify-center gap-2 rounded-md bg-primary-500 px-7 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-apple-fill text-lg" />
                  下载 iOS 版
                </a>
                <a
                  href="#top"
                  className="inline-flex h-12 items-center justify-center gap-2 rounded-md border border-primary-300 bg-primary-50 px-7 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-100 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-android-fill text-lg" />
                  下载 Android 版
                </a>
              </div>

              <div className="mt-6 flex flex-wrap items-center gap-x-6 gap-y-2 text-xs text-foreground-500">
                <span className="flex items-center gap-1.5">
                  <i className="ri-shield-check-line text-secondary-500" />
                  无账号也可浏览
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-refresh-line text-secondary-500" />
                  每日热度更新
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-bookmark-3-line text-secondary-500" />
                  清单一键收藏
                </span>
              </div>
            </div>

            <div className="lg:col-span-5 p-6 md:p-10">
              <div className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
                <p className="text-xs font-medium tracking-widest text-secondary-600">QUICK ENTRY</p>
                <h3 className="mt-2 font-heading text-lg font-bold text-foreground-950">
                  网页版快捷入口
                </h3>
                <div className="mt-4 space-y-2.5">
                  <a
                    href="#ranking"
                    className="group flex items-center justify-between rounded-md border border-background-200 bg-background-50 px-4 py-3 text-sm text-foreground-800 transition-colors hover:border-primary-300 cursor-pointer"
                  >
                    <span className="flex items-center gap-2.5">
                      <i className="ri-fire-line text-accent-600" />
                      今日热度榜
                    </span>
                    <i className="ri-arrow-right-line text-foreground-400 group-hover:text-primary-600" />
                  </a>
                  <a
                    href="#roundup"
                    className="group flex items-center justify-between rounded-md border border-background-200 bg-background-50 px-4 py-3 text-sm text-foreground-800 transition-colors hover:border-primary-300 cursor-pointer"
                  >
                    <span className="flex items-center gap-2.5">
                      <i className="ri-list-check-2 text-primary-600" />
                      本周盘点清单
                    </span>
                    <i className="ri-arrow-right-line text-foreground-400 group-hover:text-primary-600" />
                  </a>
                  <a
                    href="#directory"
                    className="group flex items-center justify-between rounded-md border border-background-200 bg-background-50 px-4 py-3 text-sm text-foreground-800 transition-colors hover:border-primary-300 cursor-pointer"
                  >
                    <span className="flex items-center gap-2.5">
                      <i className="ri-folder-open-line text-secondary-600" />
                      看料目录总览
                    </span>
                    <i className="ri-arrow-right-line text-foreground-400 group-hover:text-primary-600" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}